/* eslint-disable */
let groundsCallBackIndex = 0;

function _creatFun(callback) {
    const funName =
        '__grounds_' + Number(Math.floor(Math.random() * 10000000000)).toString(36) + groundsCallBackIndex++;
    window[funName] = function(msg) {
        callback(msg);
    };
    return funName;
}

export const interactive = {
    // 自定义 callback 函数名调用 grounds 上的方法
    intercall: (appCommand, callback) => {
        const funName = _creatFun(callback);
        grounds[appCommand](funName);
    },

    // 自定义 callback 函数名监听 grounds 上事件
    on(appCommand, callback) {
        const funName = _creatFun(callback);
        grounds.on(appCommand, funName);
    },

    // 判断用户是否登录
    userIsLogin: () => {
        return grounds.userIsLogin();
    },

    // 拉起客户端登录界面
    userLogin: () => {
        grounds.userLogin();
    },
    /**
     * 执行分享
     *
     * @param shareurl   分享链接
     * @param title      标题
     * @param desc       简介
     * @param thumbnail  分享图片
     * @param documentId 分享id
     */
    openShare: (...arg) => {
        grounds.openShare(...arg);
    },
    /** 跳转到APP指定页面
     *
     * type: 指定页面类型
     * url:  指定页面参数, 由type决定对应规则
     *
     * eg:
     *  跳web： grounds.dispatch("web", "https://user.iclient.ifeng.com/payment_home_product/index?webkit=1&gv=5.6.7&os=ios_10.3.3&proid=ifengnews"); // 跳到充值界面, gv, os, proid可从getDeviceInfo中获取
     *  跳文章：grounds.dispatch("doc", url);     // url为文章id  如果前缀没有ucms_需要自己拼接前缀
     *  跳视频：grounds.dispatch("phvideo",url); // url为视频的guid 需要拼接video_前缀
     *  跳幻灯：grounds.dispatch("slide", url); // url为请求幻灯数据的接口地址，一般为https://api.3g.ifeng.com/ipadtestdoc?aid=ucms_${id}
     */
    dispatch: function(type, url) {
        grounds.dispatch(type, url);
    },

    // 推送设置页跳转
    pushSwitch: function() {
        grounds.pushSwitch();
    },

    pushState: function(callback) {
        // FIXME：要求客户端修改 pushState 方法
        window.pushStateCallBack = state => {
            callback(state);
            window.pushStateCallBack = null;
        };
        grounds.pushState();
    },

    // 安卓通知 检查是否是系统开，端内关
    isPushActivated: function(callback) {
        grounds.isPushActivated('isPushActivatedCallBack');
        window.isPushActivatedCallBack = state => {
            callback(state);
        };
    },

    // 推送设置页跳转
    gotoTabMenu: function(tabMenu, channelId) {
        grounds.gotoTabMenu(tabMenu, channelId);
    },

    // 最大化webview
    maximization: () => {
        if (typeof grounds.maximization !== 'undefined') {
            grounds.maximization();
        }

        if (typeof grounds.setMultiToolBarHidden !== 'undefined') grounds.setMultiToolBarHidden(true);
    },
    // 退出最大化webview
    exitMaximization: () => {
        if (typeof grounds.exitMaximization !== 'undefined') {
            grounds.exitMaximization();
        }

        if (typeof grounds.setMultiToolBarHidden !== 'undefined') grounds.setMultiToolBarHidden(false);
    },

    // 隐藏客户端标题栏
    setMultiToolBarHidden: bool => {
        if (typeof grounds.setMultiToolBarHidden !== 'undefined') grounds.setMultiToolBarHidden(bool);
    },

    // 旋转webview
    // type 1 旋转到横屏 0 旋转到竖屏
    rotate: type => {
        grounds.rotate(type);
    },
    // 关闭
    close: () => {
        grounds.close();
    },

    // 设置Native分享按钮
    setShareVisibility: visible => {
        grounds.setShareVisibility(visible);
    },

    // 拉取存储键值对
    keyValueFetch: (key, callback) => {
        const funName = _creatFun(callback);
        grounds.keyValueFetch(key, funName);
    },

    // 存储键值对
    keyValueStore: (key, value) => {
        grounds.keyValueStore(key, value);
    },

    // 通知客户端签到成功
    signInSuccess: () => {
        grounds.signInSuccess();
    },

    /**
     * 客户端代理http/https请求
     * 客户端负责拼接参数、post加密、将接口请求下拉的json数据，
     *
     * @param standards  是否需要客户端的标参.
     * @param postParams post参数键值对.
     * @param getParams  get参数键值对
     * @param type       get/post/enpost
     * @param url        base url string.
     */
    nativeRequest: params => {
        params.getParams = params.getParams || '';
        params.postParams = params.postParams || '';
        params.standards = true;

        return new Promise(resolve => {
            const funName = _creatFun(data => {
                resolve(JSON.parse(decodeURIComponent(data)));
            });

            grounds.requestBridge(
                params.url,
                params.postParams,
                params.getParams,
                params.type,
                params.standards,
                funName,
            );
        });
    },

    // 三端组件信息流跳转
    jumpInNative: item => {
        switch (item.type) {
            case 'article':
                return grounds.dispatch('doc', `ucms_${item.base62Id}`);
            case 'video':
                return grounds.dispatch('phvideo', `ucms_${item.base62Id}`);
            case 'slide':
                return grounds.dispatch('slide', `https://nine.ifeng.com/GetNewsDocs?aid=ucms_${item.base62Id}`);
            case 'special':
                return grounds.dispatch('topic3', `https://nine.ifeng.com/newTopic?topicid=${item.base62Id}&json=y`);
            default:
                return grounds.dispatch('web', item.url);
        }
    },
};
